import { useEffect, useState } from "react";
import {
    BrowserRouter,
    Routes,
    Route
} from "react-router-dom";
import {
    onAuthStateChanged,
} from "firebase/auth";
import MainPage from "../pages/home/MainPage";
import { SpotsMain } from "../pages/near-spots/SpotsMain";
import { SpotView } from "../pages/near-spots/SpotView";
import { useRequest } from "../hooks/useRequest";
import { getApiUrl } from "../app-config";
import { useDispatch } from "react-redux";
import { setData } from "../core/actions/appActions";
import { setUi } from "../core/actions/graphicalActions";
import { RoomServicesRouter } from "./RoomServicesRouter";
import { RoomRouter } from "./RoomRouter";
import { HotelInformationRouter } from "./HotelInformationRouter";
import { AuthRouter } from "./AuthRouter";
import { RestaurantsRouter } from "./RestaurantsRouter";
import { auth } from "../firebase-config";
import { setLogin } from "../core/actions/authActions";
import { ToursRouter } from "./ToursRouter";
import FullLoaderComponent from "../components/loaders/FullLoaderComponent";
import { ExperienciesRouter } from "./ExperienciesRouter";
import { GymRouter } from "./GymRouter";
import { GalleryMainPage } from "../pages/gallery/GalleryMainPage";
import { SpaRouter } from "./SpaRouter";

export const AppRouter = () => {

    const dispatch = useDispatch();

    //Obtener datos para renderizar hotel
    const { data } = useRequest(getApiUrl('Hotel/3'));

    //Identificador de sesion
    const [islogged, setIsLogged] = useState(false);

    //Loader inicial
    const [checking, setChecking] = useState(true);

    //Obtener datos de sesion de usuario FIREBASE
    useEffect(() => {
        const unsuscribe = onAuthStateChanged(auth, (currentUser) => {
            if (currentUser?.uid) {
                dispatch(setLogin(currentUser));
                setIsLogged(true);
            } else {
                setIsLogged(false);
            }
        })
        return () => {
            unsuscribe();
        }
    }, [dispatch, setIsLogged])

    //Setear datos del hotel
    useEffect(() => {
        if (data) {
            dispatch(setUi(JSON.parse(data.graphicalConfig)));
            dispatch(setData(data));
            setChecking(false);
        }
    }, [dispatch, data]);

    //Preloader
    if (checking) {
        return (<FullLoaderComponent msg={'Obtieniendo información del hotel'} />)
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<MainPage />}></Route>
                <Route path="auth/*" element={<AuthRouter isAuthenticated={islogged} />} />
                <Route path="hotel-info/*" element={<HotelInformationRouter />} />
                <Route path="rooms/*" element={<RoomRouter />}></Route>
                <Route path="room-service/*" element={<RoomServicesRouter />} ></Route>
                <Route path="restaurants/*" element={<RestaurantsRouter />} ></Route>
                <Route path="experiencies/*" element={<ExperienciesRouter />} ></Route>
                <Route path="tours/*" element={<ToursRouter />} ></Route>
                <Route path="gym/*" element={<GymRouter />} ></Route>
                <Route path="spa/*" element={<SpaRouter />} ></Route>
                <Route path="gallery" element={<GalleryMainPage />} ></Route>

                <Route path="/near-spots">
                    <Route index element={<SpotsMain />} />
                    <Route path="spot/:spotid" element={<SpotView />} />
                </Route>
            </Routes>
        </BrowserRouter>
    )
}